import './accordion.css';

const AccordionDataButtons = [
    { 
      title: 'План-график готовности жилищного фонда и ТСО к эксплуатации в отопительный период',
      description: "План-график готовности жилищного фонда к эксплуатации в отопительный период",
      buttons: [
        { title: '2026/2027г.', document: 'grafik_ppr_kotelnykh_2026-2027.pdf' },
        { title: '2025/2026г.', document: '' },
        { title: '2024/2025г.', document: 'plan_otopl_2024.pdf' },
        { title: '2023/2024г.', document: 'plan_otopl_2023-2024.pdf' },
        { title: '2022/2023г.', document: 'plan_otopl_2022-2023.pdf' },
        { title: '2020/2021г.', document: 'plan_otopl_2020-2021.pdf' }
      ]
    },
    {
      title: 'График планового профилактического ремонта и обслуживания котельных городского округа Пушкинский Московской области при подготовке к осенне-зимнему периоду',
      description: "График планового профилактического ремонта и обслуживания котельных",
      buttons: [
        { title: '2026/2027г.', document: 'grafik_ppr_kotelnykh_2026-2027.pdf' },
        { title: '2025/2026г.', document: '' },
        { title: '2023/2024г.', document: 'grafik_ppr_2023.pdf' },
        { title: '2019/2020г.', document: 'grafik_ppr_2019.pdf' }
      ]
    },
    { 
      title: 'План текущего ремонта',
      description: "План текущего ремонта",
      buttons: [
        { title: '2024/ 2025г.', document: 'Plan_2024-2025.xlsx' },
        { title: '2023/2024г.', document: 'Plan_2023.zip' }
      ]
    },
    { 
      title: 'График гидравлического испытания систем отопления',
      description: "График гидравлического испытания систем отопления",
      buttons: [
        { title: '2024г.', document: 'gidravlicheskiye_ispytaniya.xlsx' },
      ]
    },
        {
      title: 'График технического обслуживания газового оборудования',
      description: "График технического обслуживания газового оборудования",
      buttons: [
      { title: '2026г.', document: 'vdgo-2026.xlsx' },
      ]
    },
    {
      title: 'План мероприятий по подготовке объектов топливно-энергетического хозяйства к отопительному периоду',
      description: "План мероприятий по подготовке объектов топливно-энергетического хозяйства к отопительному периоду",
      buttons: [
        { title: '2026/2027г.', document: 'plan_otopl_2026-2027.pdf' },
        { title: '2025/2026г.', document: 'plan_otopl_2025-2026.pdf' }
      ]
    },
  ];
  
  export default AccordionDataButtons;